import { useEffect, useState } from "react"
import { Box } from "@mui/material"
import { PrincipalLayouts } from "../../layouts"
import { CompaniesTable } from "../components/companies/CompaniesTable"
import { useTranslation } from "react-i18next"
import { fetchData } from "../helpers/getData/fetchData"

export const Companies = () => {

  const {t} = useTranslation('global')
  const [companiesList, setCompaniesList] = useState('loading')
  const [reloadData, setReloadData] = useState(false)

  useEffect(() => {
    fetchData(setCompaniesList, '/companies', t);
  }, [reloadData, t])

  return (
    <PrincipalLayouts>
      <Box sx={{ width: '100%' }}>
        {
          companiesList !== 'loading' &&
          <CompaniesTable rows={companiesList} setReloadData={setReloadData} />
        }
      </Box>
    </PrincipalLayouts>
  )
}
